import React from 'react'

export const sneakers = (props) => {

    return(
        <div>sneakers Page</div>
    )


}
